import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, {
  Mapped,
  Optional,
  Union,
} from "@/__main__/data-model.mjs";

export const NEWS_GAMES_LIST = [
  "apex",
  "valorant",
  "eft",
  "fortnite",
  "minecraft",
] as const;
const SUPPORTED_GAMES = Union(NEWS_GAMES_LIST);

const LatestModelDef = {
  expiry: Optional(Number),
  fortnite: [String],
  minecraft: Optional([String]), // Optional should be removed once minecraft has been released on the BE
  ...Mapped({
    key: SUPPORTED_GAMES,
    value: String,
  }),
} satisfies ModelDefinition;
const ArticlePreviewDef = {
  title: String,
  excerpt: String,
  imgUrl: String,
  styles: Optional(Mapped({ key: String, value: String })),
  date: Optional(Number),
};
const ArticleDef = {
  sections: [
    // Section
    [
      Union([
        // SectionItem
        {
          type: Union([
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "video",
            "image",
            "youtube",
            "paragraph",
            "list-item",
            "strong",
            "em",
          ]),
          value: String,
        },
        {
          type: Union(["table"]),
          value: [[Union([String, Number])]],
        },
      ]),
    ],
  ],
} satisfies ModelDefinition;

export const LatestModel = createModel(LatestModelDef);
export const ArticlePreviewModel = createModel(ArticlePreviewDef);
export const ArticleModel = createModel(ArticleDef);

export type NewsGamesList = (typeof NEWS_GAMES_LIST)[number]; //
export type Latest = FromModel<typeof LatestModel>;
export type ArticlePreview = FromModel<typeof ArticlePreviewModel>;
export type Article = FromModel<typeof ArticleModel>;
export type News = {
  preview: Record<string, ArticlePreview>;
  articles: Record<string, Article>;
  latest: {
    staging: Latest;
    production: Latest;
  };
};
